import { render, staticRenderFns } from "./PartnerEdit.vue?vue&type=template&id=58916451&"
import script from "./PartnerEdit.vue?vue&type=script&lang=js&"
export * from "./PartnerEdit.vue?vue&type=script&lang=js&"
import style0 from "./PartnerEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports